import { render } from "./DragDrop.vue?vue&type=template&id=a3143a72&scoped=true"
import script from "./DragDrop.vue?vue&type=script&lang=js"
export * from "./DragDrop.vue?vue&type=script&lang=js"

import "./DragDrop.vue?vue&type=style&index=0&id=a3143a72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a3143a72"

export default script